module.exports = __webpack_public_path__ + "img/perfectCookie-small.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/perfectCookie-small.png
// module id = 7
// module chunks = 0